module.exports = __webpack_public_path__ + "static/img/06.a425bd0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/artical/medical/06.png
// module id = ZXuu
// module chunks = 1